import React, { Component } from 'react';
import PathContext from "../../context/path";
import Cards from '../../components/Cards';
import FooterCover from '../../components/FooterCover';
import Footer from '../../components/Footer';
// import ScrollTop from '../../components/ScrollTop';
import Socials from '../../components/Socials';
import ScrollDown from '../../components/ScrollDown';
import styles from './Risk.module.sass';

class Risk extends Component {
	state = {
		initGif: false,
		start: 0,
		date: 2000
	}
	refGif = React.createRef();
	refWrap = React.createRef();
	interval = null;
	static contextType = PathContext;
	path = this.context;
	componentDidMount() {
		window.scrollTo(0, 0);

		window.addEventListener('scroll', this.checkGif.bind(this));

		const refGif = this.refGif.current;
		
		this.setHeight = this.setHeight.bind(this);
		this.setHeight();
		window.addEventListener('resize', this.setHeight);
		this.setState({
			start: refGif.getBoundingClientRect().top + window.scrollY - window.innerHeight / 2,
		});
	}
	
	setHeight() {
		let vh = window.innerHeight * 0.01;
		this.refWrap.current.style.setProperty('--vh', `${vh}px`);
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.setHeight, false);
		window.removeEventListener('scroll', this.checkGif.bind(this));
		this.setState = (state, callback) => {
			return;
		};
	}
	componentDidUpdate() {
		if (this.state.initGif) {
			clearInterval(this.interval);
			this.interval = setInterval(() => {
				if (this.state.date < 2021) {
					this.setState({
						date: this.state.date + 1
					});
				} else {
					clearInterval(this.interval);
				}
			}, 95);
		} else {
			clearInterval(this.interval);
			this.interval = setInterval(() => {
				if (this.state.date > 2000) {
					this.setState({
						date: this.state.date - 1
					});
				} else {
					clearInterval(this.interval);
				}
			}, 95);
		}
	}
	checkGif() {
		if (window.scrollY > this.state.start) {
			if (!this.state.initGif) {
				this.setState({
					initGif: true,
				});
			}


		} else {
			if (this.state.initGif) {
				this.setState({
					initGif: false,
				});
			}
		}
	}

	render() {
		let gifClass = `${styles.gif}`;
		if (this.state.initGif) {
			gifClass = `${styles.gif} ${styles.gif_active}`;
		} else {
			gifClass = `${styles.gif}`;
		}
		
		return <div  ref={this.refWrap} className={styles.wrap}>

			{/* BG */}
			<div className={styles.bg1}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/risk-bg-desktop.png`} />
					<img src={`${this.path}/img/risk-bg.png`} alt=""/>
				</picture>
			</div>
			<div className={styles.bg2}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/risk-bg2-desktop.png`} />
					<img src={`${this.path}/img/risk-bg2.png`} alt=""/>
				</picture>
			</div>
			{/* COVER */}
			<div className={styles.cover}>
				<div className="container">
					<h1 className={styles.title}>
					Could I be in the risk group?
					</h1>
					<div className={styles.subtitle} data-aos="fade-up">
					Ways HIV can be transmitted and how to stay safe
					</div>
					<div className={styles.socials}>
					<Socials suffix={'blue'}/>
					</div>
					<div className={styles.img}>
						<img src={`${this.path}/img/gifs/icon1.gif`} alt="" loading="lazy"/>
					</div>
				</div>
				<ScrollDown />
			</div>

			<div className={styles.info}>
				<div className="container">
					<div  data-aos="fade-up">
					<h2>The HIV infection will afflict anyone, irrespective of their position in society, sexual orientation or occupation</h2>
					<div className={styles.text}>
						<p>Over the last two decades, HIV infection has stopped being an issue for minority groups alone.</p>
					</div>
					</div>

					<div ref={this.refGif} className={gifClass}>
						<div className={styles.gif_title}><b>HIV infection groups</b></div>
						<div className={styles.gif_number}>{this.state.date}</div>
						<div className={styles.gif_bar}>
							<span className={`${styles.gif_subbar} ${styles.gif_subbar_blue}`}></span>
							
							<span className={`${styles.gif_subbar} ${styles.gif_subbar_red}`}></span>
						</div>
					</div>
					<div className={styles.bar_text}  data-aos="fade-up">
						<span>Drug users, homosexuals and sex workers </span>were the main risk groups in the 1990s, and that became a stereotype. From 2000 onwards, however, the situation changed, and today in 65% of cases HIV is transmitted through <span>heterosexual</span>  sex.
					</div>

					<div className={styles.lead}  data-aos="fade-up">Different kinds of people, irrespective of their interests and activities, sexual preferences and the amount of money in their bank accounts, are infected with HIV</div>
					<div className={styles.text}  data-aos="fade-up">
					Today, the majority of new HIV cases being detected are among middle-aged people.
					</div>
					<div className={styles.stats_wrap}>
					<div className={styles.stats}>
						<svg className={styles.svg} width="190" height="190" viewBox="0 0 190 190" fill="none" xmlns="https://www.w3.org/2000/svg">
							<circle cx="95" cy="95" r="80" strokeWidth="15" stroke="#E2E2E2"></circle>
							<circle className={styles.svg_circle} cx="95" cy="95" r="80" strokeWidth="15" stroke="#2F80ED"></circle>
						</svg>
						{/* <div className={styles.stats_img}>
						<picture>
							<source media="(min-width: 768px)" srcSet={`${this.path}/img/stats-img-desktop.png`} />
							<img src='' alt="" loading="lazy"/>
						</picture>
						</div> */}
					</div>
					<div className={styles.fact}  data-aos="fade-up">
						<div className={styles.fact_number}>30-49 years of age</div>
						<div className={styles.fact_text}>that’s the age group that accounts for 71% of people being identified as HIV-positive for the first time</div>

					</div>
					</div>
					<div className={styles.quote}  data-aos="fade-up">
						<div className={styles.quote_icon}>
							<img src={`${this.path}/img/quote.svg`} alt="" />
						</div>
						<div className={styles.quote_text}>HIV doesn’t select people according to their way of life, age or any other criteria: the epidemic has spread beyond specific groups and people who think that HIV doesn’t have anything to do with them are very much at risk, because they don’t carry out tests and don’t think about protection. Among adults there are even patients with HIV who were infected by the virus a long time ago and, luckily, found out about it, just as there are many who were infected by recent contacts."</div>
						<div className={styles.quote_name}>Anton Yeremin, </div>
						<div className={styles.quote_status}>infectious disease physician</div>
					</div>
				</div>
			</div>

			<div className={styles.info_2}>
				<div className="container">
					<div   data-aos="fade-up">
					<h2>The main infection pathway: unprotected sex</h2>
					<div className={styles.text}>
						<p>In order to infect a person, a sufficient quantity of HIV must come into contact with mucus. This sufficient quantity of the virus is contained in blood, sperm, pre-ejaculatory fluid, vaginal lubricants and breast milk.</p>
					</div>
					</div>
					<div className={styles.fact_2}>
						<div className={styles.fact_img}>
							<picture>
								<source media="(min-width: 768px)" srcSet={`${this.path}/img/risk-img-1-desktop.png`} />
							<img src={`${this.path}/img/risk-img-1.png`} alt="" />
							</picture>
						</div>
						<div  data-aos="fade-up">
						<div className={styles.fact_number}>7 out of 10</div>
						<div className={styles.fact_text}>people are infected with HIV through unprotected sex</div>
						</div>

					</div>
					<div className={`${styles.text_2}`}  data-aos="fade-up">
						<p>HIV cannot be transmitted through the air, through kissing, through touch, cutlery and crockery, the shower, the toilet or other domestic items.</p>
						<p>You can kiss in a bar without any concerns, but when it gets to sex — use protection!</p>
					</div>
					<div className={styles.illustration}>
						<picture>
							<source media="(min-width: 768px)" srcSet={`${this.path}/img/gifs/gruppa-riska-desktop.gif`} />
							<img src={`${this.path}/img/gifs/gruppa-riska.gif`} alt="" loading="lazy"/>
						</picture>
					</div>
				</div>
			</div>


			<div className={styles.info_3}>
				<div className="container">
					<div  data-aos="fade-up">
					<h2>Know your HIV status in order to be safe</h2>
					<div className={styles.text_3}>
						<p>Even the most informed people, from time to time, have unprotected sex — they don’t have any form of protection to hand, their partner asked them to, the condom breaks or for some other reason. </p>
						<p>Testing should be done by all at least once a year. That can form a habit, remove fear of the test, and give you some form of insurance if you were at risk but didn’t notice. </p>
						<p>If you’ve had sex even once without a condom, you should get tested.</p>
					</div>
					</div>
					<div className={`${styles.quote} ${styles.quote_2}`}>
						<div className={styles.quote_icon}>
							<img src={`${this.path}/img/quote.svg`} alt="" />
						</div>
						<div className={styles.quote_text}   data-aos="fade-up">We recommend that you have an HIV test every year, irrespective of what risks you may or may not have taken. People who are at a high risk level should take it every half a year and those who inject drugs or have sex under the influence should take it every 3 months. If you have been at risk, then you should take the test 3 months later in order to get an accurate result. If you haven’t been tested for over a year before the incident that put you at risk took place, then you should do two tests — immediately, and again 3 months later."</div>
						<div className={styles.quote_img}  data-aos="fade-up">
						<picture >
							<source media="(min-width: 768px)" srcSet={`${this.path}/img/risk-img-3-desktop.svg`} />
							<img src={`${this.path}/img/risk-img-3.svg`} alt="" loading="lazy"/>
						</picture>
							
						</div>
						<div  data-aos="fade-up">
						<div className={styles.quote_name}>Maya Demidova, </div>
						<div className={styles.quote_status}>testing coordinator</div>
					</div>
					</div>
				</div>
			</div>
			<div className={styles.faq}>
				<div className="container">

					<div className={styles.footer_cover}>
						<FooterCover />
					</div>
					<div className={styles.cards}>
						<Cards />
					</div>
				</div>
			</div>
			{/* <ScrollTop color={'blue'} /> */}
			<div className={styles.footer}>
				<Footer />
			</div>
		</div>;
	}
}

export default Risk;
